// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderStatusMessage_container__8l_TI","description":"OrderStatusMessage_description___mRYT"};